export default {
  name: 'ComponentsDisplay',
};
